import 'antd/lib/input/style'
import './input.less'

export * from './input'

import { Input } from './input'

export default Input
